<script>
import Layout from '@layouts/main.vue'
import BasePopover from '@components/_base-popover.vue'
import BaseConnections from '@components/_base-conections.vue'
import BaseVidPLayer from '@components/_base-vidplayer.vue'
import BlankButton from '@components/blank-button.vue'

export default {
  page: {
    title: '02 01 Planning Location A',
    meta: [
      { name: 'description', content: 'The 02 00 Planning Location Page.' },
    ],
  },
  components: {
    Layout,
    BasePopover,
    BaseConnections,
    BaseVidPLayer,
    BlankButton,
  },
  methods: {
    nextSlide() {
      const vidComp = this.$refs.bgVideo
      this.fadeStage()
      vidComp.onPlay()
    },
    prevSlide() {
      this.fadeStage()
      setTimeout(() => {
        this.$router.push('/01-B-exploration-drilling')
      }, 1500)
    },
    fadeStage() {
      this.$refs.fadeStage.classList.add('go')
    },
  },
}
</script>

<template>
  <Layout
    way-name="Planning"
    next-loc="Location D"
    next-title="ROCK CHARACTERIZATION"
  >
    <BaseVidPLayer
      ref="bgVideo"
      src="1C_ResourceModel.mp4"
      poster="journey1-C.png"
      next-path="01-D-rock-characterization"
      :pause="2"
    />
    <BlankButton
      blank-height="125px"
      blank-width="275px"
      blank-x="0"
      blank-y="65px"
      @click.native="nextSlide"
    />
    <BlankButton
      blank-height="125px"
      blank-width="105px"
      blank-x="275px"
      blank-y="65px"
      @click.native="prevSlide"
    />
    <div ref="fadeStage" class="fadeStage">
      <BaseConnections d-val="M0,0, L27,27, L16,70 L5,100" />
      <BasePopover
        pos-orient="top-right"
        :position="[80, 650]"
        id-name="box1"
        class-name="box1Class"
        box-color="white"
        hotspot-id="hotspotting"
        hotspot-class="hotspotting"
        :hot-spot-x="26.8"
        :hot-spot-y="54"
        delay-start="10"
      >
        <div class="flex m-b-15">
          <div class="m-r-10">
            <img
              :src="require('@assets/images/map-icon.png')"
              alt="map-icon"
              style="height: 55px;"
            />
          </div>
          <div>
            <h5>02 PLANNING: LOCATION D</h5>
            <h2>BUILD A SOUND <br />RESOURCE MODEL</h2>
          </div>
        </div>
        <p>
          Make your resource model<br />
          auditable with shared access.<br /><br />
          Improve data reliability<br />
          with advanced software <br />algorithms.
        </p>
      </BasePopover>
      <BasePopover
        pos-orient="bottom-right"
        :position="[100, 180]"
        id-name="box2"
        class-name="box2Class"
        hotspot-id="hotspotting2"
        hotspot-class="hotspotting2"
        :hot-spot-x="27"
        :hot-spot-y="32"
        delay-start="5000"
      >
        <div>
          <h3>BUILD A SOUND <br />RESOURCE MODEL</h3>
          <ul class="m-l-20">
            <li>Security roles, audit <br />trail and flexible data sources</li>
            <li>Easily build workflows</li>
            <li>Integrates with other <br />geology solutions</li>
            <li>Easily launch Model <br />Calculation tool</li>
          </ul>
        </div>
      </BasePopover>
      <BasePopover
        pos-orient="bottom-left"
        :position="[550, 170]"
        id-name="box3"
        class-name="box3Class"
        hotspot-id="hotspotting3"
        hotspot-class="hotspotting3"
        :hot-spot-x="26.8"
        :hot-spot-y="30"
        delay-start="6000"
      >
        <div>
          <h3>INTERPOLATION</h3>
          <ul class="m-l-20">
            <li>Advanced Model Interpolation <br />tool</li>
            <li>Easy navigation</li>
            <li>Easy to audit</li>
            <li>Secure mode restricts data <br />editing in QAQC</li>
            <li>Restore modified <br />measurements to original</li>
          </ul>
        </div>
      </BasePopover>
      <BasePopover
        pos-orient="top-left"
        :position="[590, 670]"
        id-name="box4"
        class-name="box4Class"
        hotspot-id="hotspotting4"
        hotspot-class="hotspotting4"
        :hot-spot-x="27"
        :hot-spot-y="53"
        delay-start="7000"
      >
        <div>
          <h3>FULLY AUDITABLE</h3>
          <ul class="m-l-20">
            <li>Validate field-sample accuracy</li>
            <li>Reproduce, audit geological models</li>
            <li>Update quickly and easily with new data</li>
          </ul>
        </div>
      </BasePopover>
      <BaseHotspot
        spot-size="mid"
        :pos-x="23"
        :pos-y="46.8"
        pos-unit="%"
        :rot-x="0"
      />
    </div>
  </Layout>
</template>

<style lang="scss">
@import '@design';

.fadeStage {
  opacity: 1;
  transition: opacity 1s;

  &.go {
    opacity: 0;
  }
}
</style>
